import { ElementType, Suspense, lazy } from 'react'
import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import AmeSpin from './components/AmeSpin/AmeSpin'
import { PAGE_LINKS, PC_PAGE_LINKS, MOBILE_PAGE_LINKS } from './helpers/commonConsts'
import { commonUtils } from './helpers/commonUtils'

const Loadable = (Component: ElementType) => (props: any) => {
  // 判断设备类型和页面路径是否匹配
  const isMobile = commonUtils.isMobile()
  const isPcRoute = Object.values(PC_PAGE_LINKS).some((link) => window.location.pathname === link)
  const isMobileRoute = Object.values(MOBILE_PAGE_LINKS).some(
    (link) => window.location.pathname === link
  )
  // 移动端访问PC页面，跳转到移动端
  if (isPcRoute && isMobile && window.location.pathname !=='/pc/ai') {
    window.location.href = window.location.origin + PAGE_LINKS.home
    return null
  }

  // PC端访问移动端页面，跳转到PC端
  if (isMobileRoute && !isMobile) {
    window.location.href = window.location.origin + PAGE_LINKS.pcHome
    return null
  }

  return (
    <Suspense
      fallback={
        <div style={{ textAlign: 'center' }}>
          <AmeSpin fullscreen={true} />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  )
}

const HomePage = Loadable(lazy(() => import('./pages/mobile/HomePage/HomePage')))
const SearchPage = Loadable(lazy(() => import('./pages/mobile/SearchPage/SearchPage')))
const BuyRecommendPage = Loadable(
  lazy(() => import('./pages/mobile/BuyRecommendPage/BuyRecommendPage'))
)
const GoodsDetailPage = Loadable(
  lazy(() => import('./pages/mobile/GoodsDetailPage/GoodsDetailPage'))
)
const WxLoginPage = Loadable(lazy(() => import('./pages/mobile/WxLoginPage/WxLoginPage')))
const WxPayPage = Loadable(lazy(() => import('./pages/mobile/WxPayPage/WxPayPage')))
const PcHomePage = Loadable(lazy(() => import('./pages/pc/HomePage/HomePage')))
const PcGoodsDetailPage = Loadable(lazy(() => import('./pages/pc/GoodsDetailPage/GoodsDetailPage')))
const PcSearchPage = Loadable(lazy(() => import('./pages/pc/SearchPage/SearchPage')))
const JBangAiPage = Loadable(lazy(() => import('./pages/pc/JBangAiPage/JBangAiPage')))

const routes: RouteObject[] = [
  {
    path: PAGE_LINKS.home,
    element: <HomePage />,
  },
  {
    path: PAGE_LINKS.goodsDetail,
    element: <GoodsDetailPage />,
  },
  {
    path: PAGE_LINKS.wxPay,
    element: <WxPayPage />,
  },
  {
    path: `${PAGE_LINKS.search}/:searchText`,
    element: <SearchPage />,
  },
  {
    path: `${PAGE_LINKS.buyRecommend}`,
    element: <BuyRecommendPage />,
  },
  {
    path: PAGE_LINKS.pcHome,
    element: <PcHomePage />,
  },
  {
    path: PAGE_LINKS.wxLogin,
    element: <WxLoginPage />,
  },
  {
    path: `${PAGE_LINKS.pcGoodsDetail}/:goodsNamePinyin/:id/:goodsType`,
    element: <PcGoodsDetailPage />,
  },
  {
    path: `${PAGE_LINKS.pcGoodsDetail}/:goodsNamePinyin/:id/:goodsType/:resourceId`,
    element: <PcGoodsDetailPage />,
  },
  {
    path: `${PAGE_LINKS.pcSearch}/:searchText`,
    element: <PcSearchPage />,
  },
  {
    path: PAGE_LINKS.pcJBAI,
    element: <JBangAiPage />,
  },
  {
    path: '*',
    element: <Navigate to={PAGE_LINKS.home} replace />,
  },
]

export const Router = () => {
  return useRoutes(routes)
}
